<template>
  <div :id="elementId">
    <div class="overlay hide"></div>
    <v-app :id="`${elementId}-app`" class="gc-assistant">
      <assistant-sidebar
        :assistants="assistants"
        :steps="steps"
        :machine="machine"
      >
        <div ref="containerElement">
          <assistant-container :steps="steps" :machine="machine" />
        </div>
      </assistant-sidebar>
    </v-app>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api';
import AssistantContainer from '@/components/AssistantContainer.vue';
import { useResponsiveDesign } from '@/lib/ui-helper/responsive';
import { useAssistantMachine } from '@/lib/xstate/machine';
import assistants from '~/assistants';
import steps from '~/steps/steps';
import { EventBus } from './main';

export default defineComponent({
  components: { AssistantContainer },
  setup: () => {
    const { containerElement } = useResponsiveDesign();
    const elementId = process.env.VUE_APP_SITE_NAME;

    if (!elementId) {
      throw Error('No element id defined');
    }

    const machine = useAssistantMachine(steps);

    EventBus.$on('reset-data', () => {
      machine.restart();
    });

    return {
      containerElement,
      elementId,
      machine,
      steps,
      assistants,
    };
  },
});
</script>

<style scoped>
.hide {
  display: none;
}
.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 800;
  /* cursor: pointer; */
}
</style>
